import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WorkloadState {
  workloadLink: string;
  deploymentViewObject: any;
}

const initialState: WorkloadState = {
  workloadLink: "",
  deploymentViewObject: null,
};

export const workloadSlice = createSlice({
  name: "workload",
  initialState,
  reducers: {
    setDeploymentViewObject: (state, action: PayloadAction<{ workloadLink: string; data: any }>) => {
      state.workloadLink = action.payload.workloadLink;
      state.deploymentViewObject = JSON.parse(JSON.stringify(action.payload.data));
    },
  },
});

export const { setDeploymentViewObject } = workloadSlice.actions;

export const workloadReducer = workloadSlice.reducer;
